export const css = {
	root: '_1I-KjocT',
	' _key': 'ascm-theme/ascm/lcc-app/content'
};

export default css;
